/**
 * SocketMixins.js - OPTIMIZED WITHOUT AUDIO
 * Visual notifications only (Toast + Browser Notification)
 */

import io from 'socket.io-client';
import axios from "axios";

import dayjs from "dayjs";
import Swal from "sweetalert2";

export default {
  inject: {
    db: { from: 'db', default: null },
    sync_contact: { from: 'sync_contact', default: null }
  },
  computed: {
    idb() {
      return this.db && this.db.value ? this.db.value : null;
    }
  },
  data() {
    return {
      socket: null,
      socketConnected: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      _notifData: [],
      ack: 0,
      chatData: null,
      newChat: false,
      logo: require("@/assets/favicon.png"),
      // idb: inject("db"),
      whatsappStatus: false,
      isRefreshing: false,
    };
  },

  methods: {
    /**
     * Show toast notification
     */
    showToast(title, message, icon = 'info') {
      try {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        let swalIcon = 'info';
        if (icon === 'success') swalIcon = 'success';
        else if (icon === 'error') swalIcon = 'error';
        else if (icon === 'warning') swalIcon = 'warning';

        Toast.fire({
          icon: swalIcon,
          title: title,
          text: message,
        });

        console.log('Toast shown:', title);

      } catch (error) {
        console.error('Toast error:', error);
      }
    },

    /**
     * Show notification for incoming message
     */
    showIncomingMessageNotification(data) {
      try {
        const resChat = typeof data === 'string' ? JSON.parse(data) : data;

        let from = resChat.from ? resChat.from.split("@")[0] : null;
        if (!from) return;
        from = from.replace(/[^\d]/g, '');

        const senderName = resChat._data?.notifyName || resChat.name || from;
        let messageBody = resChat.body || 'New message';

        if (messageBody.length > 60) {
          messageBody = messageBody.substring(0, 60) + '...';
        }

        console.log('Showing notification for:', senderName);

        this.updateUnreadCount(from);
        
        // ✅ SMART NOTIFICATION FILTER
        // Jika sedang di halaman chat, jangan tampilkan toast dari mixin 
        // karena chat.vue sudah menangani notifikasinya sendiri secara lokal.
        if (this.$route && this.$route.name === 'chat') {
          console.log('Skipping mixin toast because user is on chat page');
          return;
        }

        // Show toast notification
        this.showToast(senderName, messageBody, 'info');

        // Browser notification
        if ('Notification' in window && Notification.permission === 'granted') {
          try {
            const notification = new Notification(senderName, {
              body: messageBody,
              icon: this.logo || '/favicon.png',
              badge: this.logo || '/favicon.png',
              tag: from,
              requireInteraction: false,
            });

            notification.onclick = function () {
              window.focus();
              window.location.href = `/#/apps/chat?phone=${from}`;
              this.close();
            };
          } catch (notifError) {
            console.error('Notification error:', notifError);
          }
        }

      } catch (error) {
        console.error('Notification error:', error);
      }
    },

    /**
     * Update unread count
     */
    updateUnreadCount(phone) {
      try {
        console.log('Updating unread for:', phone);

        let updated = false;

        // Update Vue reactive data
        if (this.chatData && Array.isArray(this.chatData)) {
          const index = this.chatData.findIndex(el =>
            el && el.telp && String(el.telp).replace(/\D/g, '') === String(phone)
          );

          if (index !== -1) {
            const currentUnread = parseInt(this.chatData[index].unread_count || 0);
            this.chatData[index].unread_count = currentUnread + 1;
            updated = true;
            console.log('Vue chatData unread updated:', this.chatData[index].unread_count);
          }
        }

        // Update localStorage
        if (localStorage.getItem("ChatData")) {
          try {
            const chatDataArray = JSON.parse(localStorage.getItem("ChatData"));
            const idx = chatDataArray.findIndex(el =>
              el && el.telp && String(el.telp).replace(/\D/g, '') === String(phone)
            );

            if (idx !== -1) {
              const currentUnread = parseInt(chatDataArray[idx].unread_count || 0);
              chatDataArray[idx].unread_count = currentUnread + 1;
              localStorage.setItem("ChatData", JSON.stringify(chatDataArray));
              updated = true;
              console.log('localStorage ChatData unread updated:', chatDataArray[idx].unread_count);
            }
          } catch (lsError) {
            console.error('localStorage update error:', lsError);
          }
        }

        if (!updated) {
          console.warn('Contact not found in ChatData:', phone);
        }

        this.updateTotalUnreadBadge();

      } catch (error) {
        console.error('Update unread error:', error);
      }
    },

    /**
     * Update total unread badge
     */
    updateTotalUnreadBadge() {
      try {
        let totalUnread = 0;

        if (localStorage.getItem("ChatData")) {
          const chatDataArray = JSON.parse(localStorage.getItem("ChatData"));

          if (Array.isArray(chatDataArray)) {
            totalUnread = chatDataArray.reduce((sum, chat) => {
              if (chat && chat.unread_count) {
                return sum + parseInt(chat.unread_count);
              }
              return sum;
            }, 0);
          }
        }

        // Fallback to Vue data if localStorage is empty
        if (totalUnread === 0 && this.chatData && Array.isArray(this.chatData)) {
          totalUnread = this.chatData.reduce((sum, chat) => {
            if (chat && chat.unread_count) {
              return sum + parseInt(chat.unread_count);
            }
            return sum;
          }, 0);
        }

        console.log('Total unread:', totalUnread);

        localStorage.setItem('totalUnread', totalUnread.toString());

        // Update badge in DOM
        const badgeElement = document.querySelector('.unread-badge');
        if (badgeElement) {
          badgeElement.textContent = totalUnread;
          badgeElement.style.display = totalUnread > 0 ? 'inline-block' : 'none';
        }

        // Update page title
        if (totalUnread > 0) {
          document.title = `(${totalUnread}) WhatsApp - New Messages`;
        } else {
          document.title = 'WhatsApp';
        }

      } catch (error) {
        console.error('Badge update error:', error);
      }
    },

    /**
     * Initialize Socket.IO Connection
     */
    initSocket() {
      console.log('Initializing Socket.IO');

      if (!localStorage.getItem("user")) {
        console.log('No user data, skipping');
        return;
      }

      const user = JSON.parse(localStorage.getItem("user"));
      const kodemb = user ? user.Company.CompanyCode : 'default';
      const token = localStorage.getItem("jwt");
      console.log('🔌 [SOCKET] Connecting to office room:', kodemb);

      if (!token) {
        console.error('No JWT token');
        return;
      }

      const socketUrl = process.env.VUE_APP_WA_BASE_URL || 'http://localhost:3030';

      console.log('Connecting:', socketUrl);

      this._notifData = JSON.parse(localStorage.getItem("notif")) || [];

      if (this.socket) {
        console.log('Closing existing socket');
        this.socket.close();
        this.socket = null;
      }

      this.socket = io(socketUrl, {
        transports: ['polling'], // websocket disabled — nginx proxy_hide_header Upgrade masih block upgrade
        autoConnect: true,
        forceNew: true,
        query: {
          Authorization: kodemb,
          token: token,
          kodemb: kodemb,
          agentID: user.ID  // diperlukan agar node bisa lookup socket by agentID saat client_assignment_sync
        },
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: this.maxReconnectAttempts,
        timeout: 10000
      });

      // Socket event handlers
      this.socket.on('connect', () => {
        console.log('Connected:', this.socket.id);
        this.socketConnected = true;
        this.reconnectAttempts = 0;
        this.checkWhatsAppStatus();
      });

      this.socket.on('disconnect', (reason) => {
        console.log('Disconnected:', reason);
        this.socketConnected = false;
      });

      this.socket.on('connect_error', (error) => {
        console.error('Connection error:', error.message);
        this.socketConnected = false;
        this.reconnectAttempts++;
      });

      this.socket.on('reconnect', (attemptNumber) => {
        console.log('Reconnected after', attemptNumber, 'attempts');
        this.socketConnected = true;
        this.reconnectAttempts = 0;
        this.checkWhatsAppStatus();
      });

      this.socket.on('status', async (status) => {
        console.log('WhatsApp status:', status);
        logSocketEvent('status', status);
        const wasReady = this.whatsappStatus;
        this.whatsappStatus = status === 'ready';

        // Sinkronisasi state komponen berdasarkan status socket
        if (status === 'ready') {
          // WhatsApp berhasil terhubung
          if (this.waSatus !== undefined) this.waSatus = 'ready';
          if (this.isConected !== undefined) this.isConected = true;
          if (this.qrCodeWa !== undefined) this.qrCodeWa = null;
          if (typeof this.stopPolling === 'function') this.stopPolling();
        } else if (status === 'qr') {
          // WAHA siap scan QR — mulai polling QR jika belum berjalan
          if (this.isConected !== undefined) this.isConected = false;
          if (this.waSatus !== undefined && this.waSatus !== 'qr_recived') this.waSatus = 'connecting';
          if (typeof this.startQRPolling === 'function') this.startQRPolling();
          if (typeof this.startStatusPolling === 'function') this.startStatusPolling();
        } else if (status === 'connecting') {
          // Session sedang starting
          if (this.isConected !== undefined) this.isConected = false;
          if (this.waSatus !== undefined && this.waSatus !== 'qr_recived') this.waSatus = 'connecting';
        } else if (status === 'disconnected') {
          // WhatsApp terputus — reset UI dan mulai polling ulang
          if (this.isConected !== undefined) this.isConected = false;
          if (this.waSatus !== undefined) this.waSatus = 'connecting';
          if (this.qrCodeWa !== undefined) this.qrCodeWa = null;
          if (this.whatsappAccount !== undefined) this.whatsappAccount = {};
          if (typeof this.stopPolling === 'function') this.stopPolling();
          if (typeof this.startStatusPolling === 'function') this.startStatusPolling();
          if (typeof this.startQRPolling === 'function') this.startQRPolling();
        }

        // Auto-refresh saat pertama kali ready (false → true)
        if (this.whatsappStatus && !wasReady) {
          console.log('🚀 [SOCKET] WA Session Connected! Triggering automatic refresh...');
          // Fetch info akun jika komponen memiliki whatsappAccount
          if (this.whatsappAccount !== undefined && this.kodemb) {
            try {
              const infoRes = await axios.get(
                process.env.VUE_APP_WA_BASE_URL + 'api/waha/whatsapp/info?kodemb=' + this.kodemb + '&clientid=abcd1234',
                { timeout: 8000 }
              );
              if (infoRes.data.status === 200) {
                this.whatsappAccount = infoRes.data.data;
              }
            } catch (_) { /* silent — info tidak kritis */ }
          }
          if (typeof this.getUser === 'function') {
            await this.getUser('All');
          }
          if (typeof this.refreshContact === 'function') {
            await this.refreshContact();
          }
        }
      });

      const self = this;

      // ✅ Helper for Socket Debugging
      const logSocketEvent = (event, payload) => {
        if (!self.socketLogs) self.socketLogs = [];
        const logEntry = {
          id: Date.now() + Math.random(),
          time: new Date().toLocaleTimeString(),
          event,
          payload: (function () {
            if (typeof payload !== 'string') return payload;
            try {
              // Only try to parse if it looks like JSON (starts with { or [ or is a quoted string)
              const trimmed = payload.trim();
              if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
                return JSON.parse(payload);
              }
              return payload;
            } catch (e) {
              return payload;
            }
          })()
        };
        self.socketLogs.unshift(logEntry);
        if (self.socketLogs.length > 50) self.socketLogs.pop(); // Keep last 50
        
        if (self.debugMode) {
          console.log(`[SOCKET-DEBUG] ${event}:`, logEntry.payload);
        }
      };

      // Handle incoming chat messages
      this.socket.on("chat", async function (data) {
        console.log("CHAT event received");
        console.log("[🚀 DEBUG-FRONTEND-CHAT] Raw CHAT event received. Data preview:", typeof data === 'string' ? data.substring(0, 150) : data);
        logSocketEvent('chat', data);

        try {
          const resChat = JSON.parse(data);

          if (!resChat || !resChat.from) {
            console.error('Invalid chat data');
            return;
          }

          let from = resChat.from ? resChat.from.split("@")[0] : null;
          if (!from) {
            console.warn("No from field");
            return;
          }
          from = from.replace(/[^\d]/g, '');

          console.log('Message from:', from);

          // 🔒 Filter: hanya proses jika kontak ada di Contact list agent ini
          // Cegah pesan "mengambang" yang kekirim ke semua agent
          let isMyContact = false;
          // Helper untuk membandingkan nomor (handle 08 vs 628)
          const isSamePhone = (p1, p2) => {
            if (!p1 || !p2) return false;
            const normalize = (p) => {
                let s = String(p).replace(/\D/g, '');
                if (s.startsWith('0')) s = '62' + s.slice(1);
                else if (s.startsWith('8')) s = '62' + s;
                return s;
            };
            return normalize(p1) === normalize(p2);
          };

          try {
            // Tunggu DB siap sebelum cek kontak
            await self.waitForDB();
            const contacts = await self.getAllContact();
            if (Array.isArray(contacts)) {
              isMyContact = contacts.some(c => isSamePhone(c.Phone, from));
            }
          } catch (e) {
            // Fallback ke ChatData jika IndexedDB gagal
            if (localStorage.getItem("ChatData")) {
              const chatArr = JSON.parse(localStorage.getItem("ChatData"));
              isMyContact = Array.isArray(chatArr) && chatArr.some(el => isSamePhone(el.telp, from));
            }
          }

          if (!isMyContact) {
            console.log('[FILTER] Kontak belum ada di list agent, mencoba sinkronisasi dari server:', from);
            
            // ✅ Fix issue chat baru pertama kali tidak muncul otomatis
            if (typeof self.refreshContact === 'function') {
                const refreshedContact = await self.refreshContact(from);
                
                // Jika refresh berhasil menemukan kontak, langsung set true
                if (refreshedContact) {
                    isMyContact = true;
                    console.log(`[🚀 DEBUG-FRONTEND-CHAT] [FILTER] ✅ Kontak ${from} ditemukan via API refresh.`);
                } else {
                    // Cek ulang dari DB sebagai fallback terakhir
                    try {
                        const retryContacts = await self.getAllContact();
                        if (Array.isArray(retryContacts)) {
                            isMyContact = retryContacts.some(c => isSamePhone(c.Phone, from));
                        }
                    } catch (e) {
                        console.error('Error re-checking contact:', e);
                    }
                }
            }

            if (!isMyContact) {
                console.log(`[🚀 DEBUG-FRONTEND-CHAT] [FILTER] ⏭️ Kontak ${from} BENAR-BENAR bukan milik agent ini setelah refresh, skip:`, from);
                return;
            } else {
                console.log(`[🚀 DEBUG-FRONTEND-CHAT] [FILTER] ✅ Kontak ${from} terverifikasi milik agent ini, memproses pesan...`);
            }
          }

          // Format message body
          let body = resChat.body || '';
          body = body.replace(/(_)([^_]+?)(_)/gs, `<i>$2</i>`);
          body = body.replace(/(\*)([^*]+?)(\*)/gs, `<b>$2</b>`);
          body = body.replace(/(~)([^~]+?)(~)/gs, `<strike>$2</strike>`);

          // Update ChatData in localStorage
          if (localStorage.getItem("ChatData")) {
            try {
              let chatDataArray = JSON.parse(localStorage.getItem("ChatData"));

              if (!Array.isArray(chatDataArray)) {
                chatDataArray = [];
              }

              let idxReplace = chatDataArray.findIndex((el) => {
                return el && el.telp && parseInt(el.telp) === parseInt(from);
              });

              if (idxReplace !== -1) {
                const mediaLabelSocket = { image: 'Image', video: 'Video', document: 'Document', audio: 'Audio', sticker: 'Sticker' };
                const isMediaSocket = resChat.hasMedia || (resChat.type && resChat.type !== 'chat' && resChat.type !== 'revoked');
                const messageDisplay = isMediaSocket ? (mediaLabelSocket[resChat.type] || 'Media') : body;
                chatDataArray[idxReplace]["message"] = messageDisplay;
                chatDataArray[idxReplace]["hasMedia"] = resChat.hasMedia || false;
                chatDataArray[idxReplace]["type"] = resChat.type || 'chat';
                chatDataArray[idxReplace]["ack"] = resChat.ack || 0;
                chatDataArray[idxReplace]["timestamp"] = resChat.timestamp || Math.floor(Date.now() / 1000);
                chatDataArray[idxReplace]["fromMe"] = resChat.fromMe || false;

                console.log("ChatData updated");
                localStorage.setItem("ChatData", JSON.stringify(chatDataArray));

                // Update Vue reactive data
                if (self.chatData && Array.isArray(self.chatData)) {
                  const vueIdx = self.chatData.findIndex(el =>
                    el && el.telp && parseInt(el.telp) === parseInt(from)
                  );
                  if (vueIdx !== -1) {
                    self.chatData[vueIdx].message = messageDisplay;
                    self.chatData[vueIdx].hasMedia = resChat.hasMedia || false;
                    self.chatData[vueIdx].type = resChat.type || 'chat';
                    self.chatData[vueIdx].ack = resChat.ack || 0;
                    self.chatData[vueIdx].timestamp = resChat.timestamp || Math.floor(Date.now() / 1000);
                    self.chatData[vueIdx].fromMe = resChat.fromMe || false;

                    console.log("Vue chatData updated");
                  }
                }

              } else {
                console.log("Contact not in ChatData:", from);
              }
            } catch (updateError) {
              console.error('Error updating ChatData:', updateError.message);
            }
          }

          // Show notification
          self.showIncomingMessageNotification(data);

          // Store notification
          try {
            const notif = localStorage.getItem("notif");
            const resData = JSON.parse(data);

            if (notif !== null) {
              let notifData = JSON.parse(notif);
              if (!Array.isArray(notifData)) notifData = [];

              var idxNotif = notifData.findIndex((el) => el && el.from === resData.from);
              if (idxNotif !== -1) {
                notifData[idxNotif] = resData;
              } else {
                notifData.push(resData);
              }
              localStorage.setItem("notif", JSON.stringify(notifData));
            } else {
              localStorage.setItem("notif", JSON.stringify([resData]));
            }
            self._notifData = JSON.parse(localStorage.getItem("notif"));
          } catch (notifStorageError) {
            console.error('Error storing notification:', notifStorageError.message);
          }

          // Emit event for other components
          if (self.onNewMessageReceived && typeof self.onNewMessageReceived === 'function') {
            // ✅ Skip callback jika di halaman chat agar tidak double (chat.vue punya listener sendiri)
            if (this.$route && this.$route.name === 'chat') {
                console.log('Skipping mixin callback on chat page');
            } else {
                self.onNewMessageReceived({ phone: from, data: resChat });
            }
          }

        } catch (error) {
          console.error('Error handling chat:', error ? error.message : 'Unknown error');
        }
      });

      // Handle agent update dari backend (saat ada pesan baru masuk)
      this.socket.on("agent_update", function (data) {
        try {
          const payload = typeof data === 'string' ? JSON.parse(data) : data;
          logSocketEvent('agent_update', payload);
          if (!payload || !payload.phone || !Array.isArray(payload.agents)) return;

          const targetPhone = String(payload.phone).replace(/\D/g, '');

          // Update agentHandle jika chat yang aktif sesuai
          if (self.phoneNumber && String(self.phoneNumber).replace(/\D/g, '') === targetPhone) {
            self.agentHandle = payload.agents.map(a => ({
              ID: a.ID,
              Name: a.Name,
              avatar: a.Avatar && a.Avatar.Original ? a.Avatar.Original : (a.Avatar && typeof a.Avatar === 'string' ? a.Avatar : null),
              Avatar: a.Avatar || null,
            }));
            if (self.agentHandle.length > 0) {
              self.assignedAgent = self.agentHandle[0];
            }
            console.log('[SOCKET] Agent updated for', targetPhone, ':', self.agentHandle.map(a => a.Name).join(', '));
          }
        } catch (err) {
          console.error('[SOCKET] agent_update error:', err.message);
        }
      });

      // Handle new unassigned customer
      this.socket.on("customer_unassigned", async function (data) {
        console.log("customer_unassigned event");
        console.log("[🚀 DEBUG-FRONTEND-NEW-CUST] customer_unassigned event received! Data preview:", typeof data === 'string' ? data.substring(0, 150) : data);
        logSocketEvent('customer_unassigned', data);

        try {
          const customerData = typeof data === 'string' ? JSON.parse(data) : data;

          if (!customerData || !customerData.Phone || !customerData.ID) {
            console.error('[🚀 DEBUG-FRONTEND-NEW-CUST] Invalid customer data structure received.');
            return;
          }

          console.log('New customer:', customerData.Phone);

          // Do not show toast for broadcasted customer_unassigned events
          // to avoid notifying agents who don't own the contact. Rely on
          // filtered `chat` events to show incoming message notifications.
          console.log('[MIXIN] customer_unassigned received — updating DB only:', customerData.Phone);

          if (self.isRefreshing) {
            console.log('Refresh in progress, skipping');
            return;
          }

          self.isRefreshing = true;

          try {
            let allContacts = await self.getAllContact();

            if (!Array.isArray(allContacts)) {
              allContacts = [];
            }

            const existingIndex = allContacts.findIndex(c =>
              c && c.Phone && parseInt(c.Phone) === parseInt(customerData.Phone)
            );

            if (existingIndex !== -1) {
              allContacts[existingIndex] = customerData;
              console.log('Updated existing customer');
            } else {
              allContacts.unshift(customerData);
              console.log('Added new customer');
            }

            // 🔥 OPTIMIZATION: Just put the updated/new contact into IndexedDB
            // Avoid clearing the whole store to prevent race conditions during concurrent events
            await self.addCustomerToDB([customerData]);

            localStorage.setItem("Contact", JSON.stringify({
              data: { Data: allContacts }
            }));

            console.log('Customer saved');
            
            // 🔥 SYNC TO SIDEBAR UI
            console.log('[🚀 DEBUG-FRONTEND-NEW-CUST] Triggering syncContactToChatData...');
            try {
              if (typeof this.syncContactToChatData === 'function') {
                console.log('[🚀 DEBUG-FRONTEND-NEW-CUST] Syncing new unassigned customer to sidebar UI:', customerData.Phone);
                this.syncContactToChatData(customerData);
              } else {
                console.warn('[🚀 DEBUG-FRONTEND-NEW-CUST] syncContactToChatData is NOT a function in this context!');
              }
            } catch (e) {
              console.error('[🚀 DEBUG-FRONTEND-NEW-CUST] Error in syncContactToChatData:', e);
            }

            if (self.$root && self.$root.$emit) {
              console.log('[🚀 DEBUG-FRONTEND-NEW-CUST] Emitting contact-list-updated to root');
              self.$root.$emit('contact-list-updated');
            }
          } finally {
            setTimeout(() => {
              self.isRefreshing = false;
              console.log('[🚀 DEBUG-FRONTEND-NEW-CUST] Refresh cycle complete for new customer.');
            }, 1000);
          }

        } catch (error) {
          console.error('Error handling customer_unassigned:', error.message);
          self.isRefreshing = false;
        }
      });

      // ✅ [ENHANCED] Handle office-wide assignment sync
      this.socket.on("customer_assigned", async function (data) {
        try {
          const payload = typeof data === 'string' ? JSON.parse(data) : data;
          logSocketEvent('customer_assigned', payload);
          if (!payload) return;

          const source = payload.pushedBy ? `Direct-Push (${payload.pushedBy})` : 'Backend-Bridge';
          console.log(`🎯 [SOCKET] Assignment sync [${source}]:`, { phone: payload.phone, customerID: payload.customerID, isGlobal: !!payload.isGlobal });

          // Trigger fetch to update full customer details in the sidebar
          // Search by phone first for the refresh API requirement
          if (payload.phone && typeof self.refreshContact === 'function') {
            await self.refreshContact(payload.phone);
            console.log('✅ [SOCKET] Sidebar synchronization complete');
            
            if (self.$root && self.$root.$emit) {
              self.$root.$emit('contact-list-updated');
            }
          }
        } catch (err) {
          console.error('[SOCKET] customer_assigned error:', err.message);
        }
      });

      // ✅ [ENHANCED] Handle office-wide unassignment sync
      this.socket.on("customer_removed", async function (data) {
        try {
          const payload = typeof data === 'string' ? JSON.parse(data) : data;
          logSocketEvent('customer_removed', payload);
          if (!payload) return;

          const phone = payload.phone ? String(payload.phone).replace(/\D/g, '') : null;
          const customerID = payload.customerID;
          const source = payload.pushedBy ? `Direct-Push (${payload.pushedBy})` : 'Backend-Bridge';
          console.log(`🚫 [SOCKET] Customer unassigned/removed [${source}]:`, { phone, customerID });

          const currentUser = self.user || JSON.parse(localStorage.getItem("user"));
          const isPrincipal = currentUser?.Jabatan?.Code === 'principal' || currentUser?.Role?.Code === 'principal';

          // Helper to find index in chatData by ID or Phone
          const findChatIdx = () => {
             if (!self.chatData || !Array.isArray(self.chatData)) return -1;
             // 1. Match by customerID if available
             if (customerID) {
               const idx = self.chatData.findIndex(el => parseInt(el.id) === parseInt(customerID));
               if (idx !== -1) return idx;
             }
             // 2. Match by phone as fallback
             if (phone) {
               return self.chatData.findIndex(el => el && el.telp && String(el.telp).replace(/\D/g, '') === phone);
             }
             return -1;
          };

          // 1. Logic for Agents: Remove from sidebar
          // 2. Logic for Principals: Just update status to unassigned but KEEP in list
          if (isPrincipal) {
             console.log('👑 [SOCKET] I am Principal, updating status instead of removing');
             const idx = findChatIdx();
             if (idx !== -1) {
               // 🔥 [VUE 3] direct property assignment is reactive, $set is not a function in Vue 3
               self.chatData[idx].status = 'unassigned';
             }
          } else {
             // 1. Remove from local Vue chatData
             const idx = findChatIdx();
             if (idx !== -1) {
               self.chatData.splice(idx, 1);
               console.log('🗑️ Removed from Vue chatData');
             }
          }

          // 2. Remove from localStorage ChatData
          if (localStorage.getItem("ChatData")) {
            try {
              let chatArr = JSON.parse(localStorage.getItem("ChatData"));
              if (Array.isArray(chatArr)) {
                const newArr = chatArr.filter(el => 
                  el && el.telp && String(el.telp).replace(/\D/g, '') !== phone
                );
                localStorage.setItem("ChatData", JSON.stringify(newArr));
                console.log('🗑️ Removed from localStorage ChatData');
              }
            } catch (e) { console.error(e); }
          }

          // 3. Remove from localStorage Contact & IndexedDB
          try {
            let allContacts = await self.getAllContact();
            if (Array.isArray(allContacts)) {
              const newContacts = allContacts.filter(c => 
                c && c.Phone && String(c.Phone).replace(/\D/g, '') !== phone
              );
              
              await self.cleanDataDB();
              await self.addCustomerToDB(newContacts);
              
              localStorage.setItem("Contact", JSON.stringify({
                data: { Data: newContacts }
              }));
              
              console.log('🗑️ Removed from Contact list & IndexedDB');

              if (self.$root && self.$root.$emit) {
                self.$root.$emit('contact-list-updated');
              }
            }
          } catch (e) { console.error(e); }

        } catch (err) {
          console.error('[SOCKET] customer_removed error:', err.message);
        }
      });

      // Handle message status changes (read receipts)
      // Label ACK: 0=PENDING, 1=TERKIRIM, 2=DITERIMA, 3=DIBACA, 4=DIPUTAR
      const ackLabelMixin = (ack) => {
        const labels = { 0: '⏳ PENDING', 1: '✅ TERKIRIM', 2: '✅✅ DITERIMA', 3: '💙 DIBACA', 4: '▶️ DIPUTAR' };
        return labels[ack] ?? `❓ UNKNOWN(${ack})`;
      };
      this.socket.on("chat_status_changed", (data) => {
        try {
          const res = JSON.parse(data);
          logSocketEvent('chat_status_changed', res);
          console.log(`[MIXIN] 🔔 chat_status_changed → ack: ${res.ack} (${ackLabelMixin(res.ack)}) | from: ${res.from} | to: ${res.to} | fromMe: ${res.fromMe} | phoneResolved: ${res.phoneResolved || '-'}`);

          if (!res || !res.fromMe) {
            console.warn(`[MIXIN] ⏭️ chat_status_changed SKIP — alasan: ${!res ? 'no data' : 'fromMe=false'}`);
            return;
          }

          // Cascade: phoneResolved (server sudah resolve LID) → to → from (fallback terakhir)
          // Untuk pesan outgoing (fromMe=true), WAHA mengisi 'from' = nomor customer/lawan bicara
          // dan membiarkan 'to' = undefined — gunakan 'from' sebagai fallback final.
          const targetRaw = res.phoneResolved
            ? `${res.phoneResolved}@c.us`
            : (res.to || res.from || null);

          if (!targetRaw) {
            console.warn(`[MIXIN] ⏭️ chat_status_changed SKIP — tidak ada target phone (phoneResolved/to/from semua kosong)`);
            return;
          }

          const toChat = targetRaw.split("@")[0].replace(/\D/g, '');
          console.log(`[MIXIN] 📞 Target phone: "${toChat}" (dari: ${res.phoneResolved ? 'phoneResolved' : res.to ? 'to' : 'from'}) | Status: ${ackLabelMixin(res.ack)}`);

          if (!toChat || toChat.length < 8) {
            console.warn(`[MIXIN] ⏭️ chat_status_changed SKIP — phone invalid/terlalu pendek: "${toChat}" (raw: ${targetRaw})`);
            return;
          }

          // Update Vue reactive data
          if (self.chatData && Array.isArray(self.chatData)) {
            const index = self.chatData.findIndex((el) =>
              String(el.telp).replace(/\D/g, '') === String(toChat)
            );

            if (index !== -1) {
              const oldAck = self.chatData[index].ack ?? 0;
              // Hanya update jika ack lebih tinggi — cegah LID ack lama menurunkan status
              if (res.ack > oldAck) {
                self.chatData[index].ack = res.ack;
                console.log(`[MIXIN] ✅ ChatList updated — phone: ${toChat} | ${ackLabelMixin(oldAck)} → ${ackLabelMixin(res.ack)}`);
              } else {
                console.log(`[MIXIN] ⏭️ ChatList skip ack downgrade — phone: ${toChat} | current: ${ackLabelMixin(oldAck)} | incoming: ${ackLabelMixin(res.ack)}`);
              }
            } else {
              console.warn(`[MIXIN] ⚠️ Phone ${toChat} tidak ditemukan di chatData (total: ${self.chatData.length}) | Cek apakah LID mapping di server sudah ada`);
            }
          }

          // Update localStorage
          if (localStorage.getItem("ChatData")) {
            const chatDataArray = JSON.parse(localStorage.getItem("ChatData"));
            const idx = chatDataArray.findIndex((el) =>
              String(el.telp).replace(/\D/g, '') === String(toChat)
            );

            if (idx !== -1 && res.ack > (chatDataArray[idx].ack ?? 0)) {
              chatDataArray[idx].ack = res.ack;
              localStorage.setItem("ChatData", JSON.stringify(chatDataArray));
              console.log(`[MIXIN] 💾 localStorage ChatData updated — phone: ${toChat}`);
            }
          }

          // Emit event for other components
          if (self.$root && self.$root.$emit) {
            self.$root.$emit('message-ack-updated', { phone: toChat, ack: res.ack, messageId: res.id });
          }

        } catch (error) {
          console.error('[MIXIN] ❌ Error in chat_status_changed:', error);
        }
      });

      console.log('All socket events registered');
    },

    /**
     * Check WhatsApp connection status
     */
    async checkWhatsAppStatus() {
      try {
        const kodemb = JSON.parse(localStorage.getItem("user"))?.Company?.CompanyCode || 'default';
        const statusRes = await axios.get(
          process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/status?kodemb=" + kodemb + "&clientid=abcd1234"
        );

        if (statusRes.data.status === 200) {
          const status = statusRes.data.data;
          this.whatsappStatus = status === 'CONNECTED';
          console.log('WhatsApp:', this.whatsappStatus ? 'Connected' : 'Disconnected');
        }
      } catch (err) {
        console.error('Status check error:', err.message);
        this.whatsappStatus = false;
      }
    },

    async syncChatRoomsWa() {
      // let contactData = JSON.parse(localStorage.getItem("Contact"));
      let contactData = {
        data: {
          Data: await this.getAllContact()
        }
      };

      let chatDataLoad = [];
      let cacheChatData = null;
      let waGateway = null;

      let kodemb = JSON.parse(localStorage.getItem("user")).Company.CompanyCode
      let urlStateWa = process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/status?kodemb=" + kodemb
      const statusWa = await axios.get(urlStateWa, {
        headers: {
          clientid: "abcd1234"
        }
      })

      let responseData = statusWa.data

      if (responseData.data !== 'WAITING') {
        for (let idx = 0; idx < contactData.data.Data.slice(0, 10).length; idx++) {
          const item = contactData.data.Data[idx];

          let Tag = [];
          if (item.Tags !== null) {
            item.Tags.forEach((element) => {
              Tag.push(element.Title);
            });
          }

          chatDataLoad.push({
            id: item.ID,
            image: item.Avatar?.Original ?? this.profile,
            name: item.Name,
            telp: parseInt(item.Phone),
            message: cacheChatData ? cacheChatData.message : "",
            hasMedia: cacheChatData ? cacheChatData.hasMedia : "",
            ack: cacheChatData ? cacheChatData.ack : 0,
            Tags: Tag.join(","),
            timestamp: cacheChatData ? cacheChatData.timestamp : 0,
            unread_count: cacheChatData ? cacheChatData.unread_count : 0,
            fromMe: cacheChatData ? cacheChatData.fromMe : false,
            status: item.Status,
            firstTimeChat: item.CreatedTime,
            shimmer: cacheChatData ? cacheChatData.shimmer : true,
            type: cacheChatData ? cacheChatData.type : "chat",
          });

          waGateway = await axios.post(
            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/chat-rooms",
            {
              phones: [item.Phone],
              kodemb: JSON.parse(localStorage.getItem("user")).Company
                .CompanyCode,
            },
            {
              headers: {
                ClientID: "abcd1234",
              },
            }
          );

          let resWa;
          if (waGateway.data.status !== 500) {
            resWa = waGateway.data.data?.[0];

            if (resWa && resWa.last_message) {
              resWa.hasMedia = resWa.last_message._data && "deprecatedMms3Url" in resWa.last_message._data;
              if (resWa.hasMedia) {
                if (resWa.last_message._data.type !== "image") {
                  resWa.last_message.type = "image";
                  resWa.last_message.hasMedia = true;
                }
              }

              const regexItalic = /(_)([^_]+?)(_)/gs;
              const regexBold = /(\*)([^*]+?)(\*)/gs;
              const regexStrike = /(~)([^~]+?)(~)/gs;

              var body = resWa.last_message.body ?? "";
              body = body.replace(regexItalic, `<i>$2</i>`);
              body = body.replace(regexBold, `<b>$2</b>`);
              body = body.replace(regexStrike, `<strike>$2</strike>`);

              if (idx !== -1) {
                var isRevoked = resWa.last_message._data?.type === "revoked" ?? false;
                chatDataLoad[idx]["message"] = isRevoked
                  ? "<i>pesan ini dihapus</i>"
                  : body;
                chatDataLoad[idx]["hasMedia"] = resWa.last_message.hasMedia;
                chatDataLoad[idx]["ack"] = resWa.last_message.ack;
                chatDataLoad[idx]["timestamp"] = resWa.last_message.timestamp;
                chatDataLoad[idx]["unread_count"] = resWa.unread_count;
                chatDataLoad[idx]["fromMe"] = resWa.last_message.fromMe;
                chatDataLoad[idx]["type"] = resWa.last_message.type;
                if (resWa.photo !== null) {
                  chatDataLoad[idx]["image"] = resWa.photo;
                }
                chatDataLoad[idx]["shimmer"] = false;
              }
            }
          }
        }
        localStorage.setItem("ChatData", JSON.stringify(chatDataLoad));
      }
    },

    /**
     * Disconnect socket
     */
    disconnectSocket() {
      if (this.socket) {
        console.log('Disconnecting socket');
        this.socket.close();
        this.socket = null;
        this.socketConnected = false;
      }
    },

    /**
     * Refresh contact list
     */
    async refreshContact(phone = 0) {
      if (this.isRefreshing) {
        console.log('Refresh already in progress');
        return;
      }

      this.isRefreshing = true;

      try {
        console.log("Refreshing contacts");
        localStorage.removeItem("Contact");
        const baseUrl = process.env.VUE_APP_URL_API;
        const addExtraParams =
          "&ClientID=" +
          process.env.VUE_APP_CLIENT_ID +
          "&AccessToken=" +
          localStorage.getItem("jwt");

        if (phone === 0) {
          // Refresh all contacts
          let userChat = await axios.get(
            baseUrl + "customer-api/getCustomerData?status=all&Kodemb=" +
            JSON.parse(localStorage.getItem("user")).Company.CompanyCode +
            addExtraParams
          );

          if (userChat.data.Data !== null && Array.isArray(userChat.data.Data) && userChat.data.Data.length > 0) {
            let sortContact = userChat.data.Data.sort(
              (a, b) =>
                this.toTimeStamp(b.TimestampLastChat) -
                this.toTimeStamp(a.TimestampLastChat)
            );
            userChat.data.Data = sortContact;
            await this.cleanDataDB();
            await this.addCustomerToDB(userChat.data.Data);

            localStorage.setItem("Contact", JSON.stringify({
              data: { Data: sortContact }
            }));

            console.log('All contacts refreshed');
          }
        } else {
          // Refresh single contact
          let userChat = await axios.get(
            `${process.env.VUE_APP_URL_API}customer-api/getCustomerByPhone`, {
            params: {
              ClientID: process.env.VUE_APP_CLIENT_ID,
              AccessToken: localStorage.getItem("jwt"),
              Phone: phone
            }
          });

          let responseData = null;
          if (userChat.status == 200) {
            let response = userChat.data;
            if (response.Meta.Code == 200) {
              responseData = response.Data;
            }
          }

          let oldContact = await this.getAllContact();

          if (!Array.isArray(oldContact)) {
            oldContact = [];
          }

          if (responseData !== null) {
            const existingIndex = oldContact.findIndex(c => c && c.Phone && parseInt(c.Phone) === parseInt(phone));
            if (existingIndex !== -1) {
              oldContact[existingIndex] = responseData;
            } else {
              oldContact.unshift(responseData);
            }
            
            // 🔥 SYNC TO SIDEBAR UI
            try {
              if (typeof this.syncContactToChatData === 'function') {
                console.log('[🚀 DEBUG-FRONTEND-REFRESH] Syncing refreshed contact to sidebar UI:', phone);
                this.syncContactToChatData(responseData);
              }
            } catch (e) {
              console.error('[🚀 DEBUG-FRONTEND] Error calling syncContactToChatData in refreshContact:', e);
            }
          }

          // 🔥 OPTIMIZATION: Just put the updated/new contact into IndexedDB
          // Avoid clearing the whole store to prevent race conditions during concurrent events
          if (responseData) {
              await this.addCustomerToDB([responseData]);
          }

          localStorage.setItem("Contact", JSON.stringify({
            data: { Data: oldContact }
          }));

          console.log('Contact refreshed');
          return responseData;
        }
      } catch (error) {
        console.error('Refresh error:', error.message);
        return null;
      } finally {
        setTimeout(() => {
          this.isRefreshing = false;
        }, 1000);
      }
    },

    /**
     * Convert date to timestamp
     */
    toTimeStamp(date) {
      return new Date(Date.parse(date)).getTime() / 1000;
    },

    /**
     * Helper to wait for IndexedDB to be ready
     */
    async waitForDB(timeout = 1000) {
      if (this.idb) return this.idb;
      
      const start = Date.now();
      return new Promise((resolve) => {
        const check = setInterval(() => {
          if (this.idb) {
            clearInterval(check);
            resolve(this.idb);
          } else if (Date.now() - start > timeout) {
            clearInterval(check);
            resolve(null);
          }
        }, 50);
      });
    },

    /**
     * Get all contacts from IndexedDB
     */
    async getAllContact() {
      const db = await this.waitForDB();
      return new Promise((resolve) => {
        if (!db) {
          console.warn("IDB not ready after wait");
          resolve([]);
          return;
        }
        try {
          let trans = db.transaction(['customer'], 'readonly');
          trans.oncomplete = () => {
            resolve(customer);
          };

          trans.onerror = (e) => {
            console.error("IndexedDB error:", e);
            resolve([]);
          };

          let store = trans.objectStore("customer");
          let objStoreReq = store.getAll();
          let customer = [];

          objStoreReq.onsuccess = () => {
            const validData = (objStoreReq.result || []).filter(item =>
              item && item.ID && item.Phone && item.TimestampLastChat
            );
            validData.sort(
              (a, b) =>
                dayjs(b.TimestampLastChat).unix() -
                dayjs(a.TimestampLastChat).unix()
            );
            customer = validData;
          };

          objStoreReq.onerror = (e) => {
            console.error("Get error:", e);
            resolve([]);
          };
        } catch (error) {
          console.error("Error getting contacts:", error.message);
          resolve([]);
        }
      });
    },

    /**
     * Add customers to IndexedDB
     */
    async addCustomerToDB(cust) {
      const db = await this.waitForDB();
      return new Promise((resolve) => {
        if (!db) {
          console.warn("IDB not ready after wait");
          resolve();
          return;
        }
        try {
          if (!Array.isArray(cust) || cust.length === 0) {
            resolve();
            return;
          }

          let trans = db.transaction(['customer'], 'readwrite');
          let store = trans.objectStore('customer');

          let addedCount = 0;

          cust.forEach((item) => {
            if (!item || typeof item.ID !== "number" || !item.Phone) {
              return;
            }

            item.id = item.ID;

            try {
              store.put(item);
              addedCount++;
            } catch (e) {
              console.warn("Put error:", e.message);
            }
          });

          trans.oncomplete = () => {
            console.log(`Added ${addedCount} customers to DB`);
            resolve();
          };

          trans.onerror = (e) => {
            console.error("Transaction error:", e);
            resolve();
          };
        } catch (error) {
          console.error("Add error:", error.message);
          resolve();
        }
      });
    },

    /**
     * Clean IndexedDB
     */
    async cleanDataDB() {
      const db = await this.waitForDB();
      return new Promise((resolve) => {
        if (!db) {
          console.warn("IDB not ready after wait");
          resolve();
          return;
        }
        try {
          let trans = db.transaction(['customer'], 'readwrite');
          let objectStore = trans.objectStore("customer");

          let clearRequest = objectStore.clear();

          clearRequest.onsuccess = () => {
            resolve();
          };

          clearRequest.onerror = (e) => {
            console.error("Clear error:", e);
            resolve();
          };
        } catch (error) {
          console.error("Clear error:", error.message);
          resolve();
        }
      });
    },
  },

  mounted() {
    console.log('SocketMixins mounted');

    // Request notification permission if not granted
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then(permission => {
        console.log('Notification permission:', permission);
      });
    }
  },

  beforeUnmount() {
    console.log('SocketMixins unmounting');
    this.disconnectSocket();
  },
};